/* =============================================
   CUSTOM QUICK CART JS — Korebi Coffee
   Self-contained, zero third-party dependencies
   Uses only Shopify AJAX Cart API + Swiper (already in theme)
   ============================================= */

(function () {
  'use strict';

  window.CQC = {
    update: function (cart) {
      if (cart) {
        this.renderCart(cart);
      } else {
        this.fetchCart();
      }
    },
    drawer: null,
    overlay: null,
    itemsContainer: null,
    emptyState: null,
    footer: null,
    milestonesEl: null,
    cart: null,
    swiperAnnounce: null,
    swiperRec: null,
    milestoneConfig: [],
    isOpen: false,
    isFetching: false,
    isInitialLoad: true,

    /* ---- Init ---- */
    init: function () {
      this.drawer = document.getElementById('custom-quick-cart');
      this.overlay = document.getElementById('custom-quick-cart-overlay');
      this.itemsContainer = document.getElementById('cqc-items');
      this.emptyState = document.getElementById('cqc-empty');
      this.footer = document.getElementById('cqc-footer');
      this.progressContainerEl = document.getElementById('cqc-progress-container');

      if (!this.drawer) return;

      this.bindEvents();
      this.interceptOldCart();
      this.initSwipers();
      
      // Mark initial load as complete (don't auto-open drawer on page load)
      this.isInitialLoad = false;
    },



    /* ---- Bind Events ---- */
    bindEvents: function () {
      var self = this;

      // Open buttons
      document.querySelectorAll('[data-custom-cart-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.open();
        });
      });

      // Close button
      this.drawer.querySelectorAll('[data-custom-cart-close]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.close();
        });
      });

      // Overlay click
      if (this.overlay) {
        this.overlay.addEventListener('click', function () {
          self.close();
        });
      }

      // Checkout button
      var checkoutBtn = document.getElementById('cqc-checkout-btn');
      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var checkoutUrl = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '/checkout';
          window.location.href = checkoutUrl;
        });
      }

      // ESC key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.isOpen) self.close();
      });

      // Delegated events for cart items
      if (this.itemsContainer) {
        this.itemsContainer.addEventListener('click', function (e) {
          var target = e.target.closest('[data-cqc-action]');
          if (!target) return;
          var action = target.getAttribute('data-cqc-action');
          var key = target.getAttribute('data-cqc-key');
          var qty = parseInt(target.getAttribute('data-cqc-qty') || '0', 10);

          if (action === 'minus') self.updateQuantity(key, Math.max(0, qty - 1));
          if (action === 'plus') self.updateQuantity(key, qty + 1);
          if (action === 'remove') self.updateQuantity(key, 0);
        });
      }

      // Freebie add-to-cart
      var freebieAddBtn = document.getElementById('cqc-freebie-add-btn');
      if (freebieAddBtn) {
        freebieAddBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var select = document.getElementById('cqc-freebie-variant-select');
          if (select) {
            self.addItem(parseInt(select.value, 10), freebieAddBtn);
          }
        });
      }

      // Recommendation add-to-cart
      document.querySelectorAll('.cqc-rec-add-btn').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var card = btn.closest('.cqc-rec-card');
          var select = card ? card.querySelector('.cqc-rec-variant-select') : null;
          var variantId = select ? select.value : btn.getAttribute('data-variant-id');
          self.addItem(parseInt(variantId, 10), btn);
        });
      });

      // Recommendation variant selector updates Add button
      document.querySelectorAll('.cqc-rec-variant-select').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var card = sel.closest('.cqc-rec-card');
          var btn = card ? card.querySelector('.cqc-rec-add-btn') : null;
          if (btn) btn.setAttribute('data-variant-id', sel.value);
        });
      });

      // Listen for theme.js cart-update events — only re-render, never auto-open
      document.addEventListener('cart-update', function (e) {
        if (e.detail) {
          self.cart = e.detail;
          self.renderCart(e.detail);
        }
      });

      // Ella theme native event — only re-render, never auto-open
      document.addEventListener('ajaxProduct:added', function () {
        self.fetchCart();
      });
    },

    /* ---- Intercept Old Cart Sidebar ---- */
    interceptOldCart: function () {
      var self = this;
      // Watch for body class 'cart-sidebar-show' being added — strip it but do NOT auto-open CQC
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (document.body.classList.contains('cart-sidebar-show') || document.body.classList.contains('add-to-cart-show')) {
              document.body.classList.remove('cart-sidebar-show', 'add-to-cart-show');
              self.open();
            }
          }
        });
      });
      observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    },

    /* ---- Open Cart ---- */
    open: function () {
      console.log('CQC: open() called');
      this.isOpen = true;
      document.body.classList.add('cqc-open');
      this.fetchCart();
    },

    /* ---- Close Cart ---- */
    close: function () {
      console.log('CQC: close() called');
      this.isOpen = false;
      document.body.classList.remove('cqc-open');
    },

    /* ---- Fetch Cart ---- */
    fetchCart: function () {
      var self = this;
      if (this.isFetching) return;
      this.isFetching = true;

      // Show loading state
      if (this.itemsContainer) {
        this.itemsContainer.innerHTML = '<div class="cqc-loading"><div class="cqc-spinner"></div></div>';
      }

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { 
          if (!r.ok) throw new Error('Cart fetch failed');
          return r.json(); 
        })
        .then(function (cart) {
          self.cart = cart;
          self.renderCart(cart);
        })
        .catch(function (err) {
          console.error('CQC: Error fetching cart', err);
        })
        .finally(function () {
          self.isFetching = false;
        });
    },

    /* ---- Render Cart ---- */
    renderCart: function (cart) {
      if (!cart) return;
      this.cart = cart;

      if (cart.item_count === 0) {
        if (this.itemsContainer) this.itemsContainer.innerHTML = '';
        if (this.emptyState) this.emptyState.style.display = 'flex';
        if (this.footer) this.footer.style.display = 'none';
      } else {
        if (this.emptyState) this.emptyState.style.display = 'none';
        if (this.footer) this.footer.style.display = 'block';
        this.renderItems(cart.items);
      }

      this.updateSubtotal(cart);
      this.updateMilestones(cart);
      this.syncCartCount(cart.item_count);
    },

    /* ---- Render Cart Items ---- */
    renderItems: function (items) {
      if (!this.itemsContainer) return;
      var html = '';
      for (var i = 0; i < items.length; i++) {
        html += this.buildItemHTML(items[i]);
      }
      this.itemsContainer.innerHTML = html;
    },

    /* ---- Build Single Item HTML ---- */
    buildItemHTML: function (item) {
      var imgSrc = item.featured_image && item.featured_image.url
        ? this.resizeImage(item.featured_image.url, '200x200')
        : (item.image ? this.resizeImage(item.image, '200x200') : '');
      var imgAlt = item.featured_image && item.featured_image.alt ? item.featured_image.alt : item.product_title;

      var hasSale = item.original_price > item.final_price;
      var hasCompare = false;
      // Check variant compare_at_price via original_line_price vs final_line_price
      if (item.original_line_price > item.final_line_price) {
        hasSale = true;
      }

      var priceHTML = '';
      if (hasSale) {
        priceHTML = '<span class="cqc-item-final-price on-sale">' + this.formatMoney(item.final_price) + '</span>' +
          '<span class="cqc-item-compare-price">' + this.formatMoney(item.original_price) + '</span>';
      } else {
        priceHTML = '<span class="cqc-item-final-price">' + this.formatMoney(item.final_price) + '</span>';
      }

      var variantHTML = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        variantHTML = '<span class="cqc-item-variant">' + this.escapeHTML(item.variant_title) + '</span>';
      }

      return '<div class="cqc-item" data-key="' + item.key + '">' +
        '<div class="cqc-item-image"><a href="' + item.url + '">' +
        '<img src="' + imgSrc + '" alt="' + this.escapeHTML(imgAlt) + '" loading="lazy" width="80" height="80">' +
        '</a></div>' +
        '<div class="cqc-item-info">' +
        '<a href="' + item.url + '" class="cqc-item-title">' + this.escapeHTML(item.product_title) + '</a>' +
        variantHTML +
        '<div class="cqc-item-bottom">' +
        '<div class="cqc-qty-widget">' +
        '<button type="button" class="cqc-qty-btn" data-cqc-action="minus" data-cqc-key="' + item.key + '" data-cqc-qty="' + item.quantity + '" aria-label="Decrease quantity">−</button>' +
        '<span class="cqc-qty-value">' + item.quantity + '</span>' +
        '<button type="button" class="cqc-qty-btn" data-cqc-action="plus" data-cqc-key="' + item.key + '" data-cqc-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<div class="cqc-item-price">' + priceHTML + '</div>' +
        '</div></div>' +
        '<button type="button" class="cqc-item-remove" data-cqc-action="remove" data-cqc-key="' + item.key + '" aria-label="Remove item">' +
        '<svg viewBox="0 0 24 24"><path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6h14zM10 11v6M14 11v6"/></svg>' +
        '</button></div>';
    },

    /* ---- Close Other Carts (Rebuy/Theme) ---- */
    closeOtherCarts: function () {
      // Remove theme sidebar classes
      document.body.classList.remove('cart-sidebar-show', 'show-sidebar-content');

      // Try to hide Rebuy SmartCart
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.hide === 'function') {
        try {
          window.Rebuy.SmartCart.hide();
        } catch (e) { }
      }

      // Specific to Halo theme
      document.querySelectorAll('.halo-sidebar').forEach(function (s) {
        s.classList.remove('show');
      });
    },

    /* ---- Update Quantity ---- */
    updateQuantity: function (key, quantity) {
      var self = this;
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self.renderCart(cart);
          self.closeOtherCarts(); // Force close apps/theme sidebars
          document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
        })
        .catch(function (err) {
          console.error('CQC: Error updating quantity', err);
        });
    },

    /* ---- Add Item (from recommendations) ---- */
    addItem: function (variantId, btn) {
      var self = this;
      if (btn) {
        btn.classList.add('adding');
        btn.textContent = 'Adding...';
      }
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { 
          if (!r.ok) throw new Error('Add failed');
          return r.json(); 
        })
        .then(function () {
          return fetch('/cart.js', { credentials: 'same-origin' });
        })
        .then(function (r) { 
          if (!r.ok) throw new Error('Cart refresh failed');
          return r.json(); 
        })
        .then(function (cart) {
          self.renderCart(cart);
          self.closeOtherCarts(); // Force close apps/theme sidebars
          document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
        })
        .catch(function (err) {
          console.error('CQC: Error adding item', err);
        })
        .finally(function () {
          if (btn) {
            btn.classList.remove('adding');
            btn.textContent = 'Add';
          }
        });
    },

    /* ---- Update Subtotal ---- */
    updateSubtotal: function (cart) {
      var countEl = document.getElementById('cqc-item-count');
      var subtotalEl = document.getElementById('cqc-subtotal-amount');
      var compareEl = document.getElementById('cqc-compare-total');

      if (countEl) countEl.textContent = cart.item_count;
      if (subtotalEl) subtotalEl.textContent = this.formatMoney(cart.total_price);

      if (compareEl) {
        if (cart.original_total_price > cart.total_price) {
          compareEl.textContent = this.formatMoney(cart.original_total_price);
          compareEl.style.display = 'inline';
        } else {
          compareEl.style.display = 'none';
        }
      }
    },

    /* ---- Update Dynamic Progress Bar ---- */
    updateMilestones: function (cart) {
      var container = this.progressContainerEl;
      if (!container) return;

      var configRaw = container.getAttribute('data-progress-config');
      if (!configRaw) return;

      var config = JSON.parse(configRaw);

      var total = cart.original_total_price || cart.total_price;
      var itemCount = cart.item_count;

      var hasSpItem = false;
      if (config.sp_collection_handles && config.sp_collection_handles.length > 0) {
        hasSpItem = cart.items.some(function(item) {
          return config.sp_collection_handles.indexOf(item.handle) !== -1;
        });
      }

      var threshold = 0;
      var textTpl = "";
      var progressVal = 0;

      if (hasSpItem && itemCount === 1 && total < config.sp_threshold) {
        threshold = config.sp_threshold;
        textTpl = config.sp_text;
      } else {
        if (total < config.tier1_threshold) {
          threshold = config.tier1_threshold;
          textTpl = config.tier1_text;
        } else if (total < config.tier2_threshold) {
          threshold = config.tier2_threshold;
          textTpl = config.tier2_text;
        } else if (total < config.tier3_threshold) {
          threshold = config.tier3_threshold;
          textTpl = config.tier3_text;
        } else {
          threshold = config.tier3_threshold; // maxed out
          textTpl = config.success_text;
        }
      }

      var fillEl = container.querySelector('.animation-bar-1 span');
      var barWrap = container.querySelector('.animation-bar-1');
      var textEl = container.querySelector('.cqc-progress-text');

      var maxThreshold = (hasSpItem && itemCount === 1 && config.sp_threshold > 0) ? config.sp_threshold : config.tier3_threshold;
      var calculatedProgress = Math.min(100, (total / maxThreshold) * 100);

      var steps = container.querySelectorAll('.cqc-milestone-step');
      var thresholds = [config.tier1_threshold, config.tier2_threshold, config.tier3_threshold];
      for (var i = 0; i < steps.length; i++) {
        var stepIndex = parseInt(steps[i].getAttribute('data-milestone-index') || i, 10);
        if (stepIndex < thresholds.length) {
          if (total >= thresholds[stepIndex]) {
            steps[i].classList.add('complete');
          } else {
            steps[i].classList.remove('complete');
          }
        }
      }

      var freebieContainer = document.getElementById('cqc-freebie-container');
      if (freebieContainer) {
        var isFreebieUnlocked = total >= config.tier3_threshold;
        var freebieId = config.freebie_product_id;
        var hasFreebieInCart = false;
        
        if (freebieId && freebieId !== 'null') {
          hasFreebieInCart = cart.items.some(function(item) {
            return item.product_id == freebieId;
          });
        }
        
        var statusText = document.getElementById('cqc-freebie-status-text');
        var addBtn = document.getElementById('cqc-freebie-add-btn');

        if (isFreebieUnlocked) {
          if (hasFreebieInCart) {
            freebieContainer.classList.add('is-claimed');
            freebieContainer.classList.remove('is-locked');
            if (statusText) statusText.textContent = 'Gift Added to Cart!';
            if (addBtn) {
              addBtn.textContent = 'Already in Cart';
              addBtn.disabled = true;
            }
          } else {
            freebieContainer.classList.remove('is-claimed', 'is-locked');
            if (statusText) statusText.textContent = "You've unlocked a Freebie!";
            if (addBtn) {
              addBtn.textContent = 'Add to Cart';
              addBtn.disabled = false;
            }
          }
        } else {
          freebieContainer.classList.add('is-locked');
          freebieContainer.classList.remove('is-claimed');
          if (statusText) statusText.textContent = 'Unlock this Gift at ' + this.formatMoney(config.tier3_threshold);
          if (addBtn) {
            addBtn.textContent = 'Locked';
            addBtn.disabled = true;
          }
        }
      }

      if (textTpl === config.success_text) {
         progressVal = 100;
         barWrap.style.display = 'block';
         textEl.innerHTML = textTpl;
      } else if (threshold > 0) {
         var amountAdd = threshold - total;
         progressVal = calculatedProgress;
         barWrap.style.display = 'block';
         var amountAddFormatted = this.formatMoney(amountAdd);
         textEl.innerHTML = textTpl.replace('[amount]', '<strong>' + amountAddFormatted + '</strong>');
      } else {
         barWrap.style.display = 'none';
         textEl.innerHTML = '';
      }

      if (fillEl) {
        fillEl.style.width = progressVal + '%';
      }
    },

    /* ---- Sync Cart Count (all badges on page) ---- */
    syncCartCount: function (count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
      });
    },

    /* ---- Init Swipers ---- */
    initSwipers: function () {
      var self = this;
      // Wait for Swiper to be available
      var attempts = 0;
      var tryInit = function () {
        if (typeof Swiper !== 'undefined') {
          self._initAnnouncementSwiper();
          self._initRecommendationSwiper();
        } else if (attempts < 20) {
          attempts++;
          setTimeout(tryInit, 200);
        }
      };
      tryInit();
    },

    _initAnnouncementSwiper: function () {
      var el = this.drawer.querySelector('.cqc-announcements-swiper');
      if (!el || el.querySelectorAll('.swiper-slide').length < 2) return;
      this.swiperAnnounce = new Swiper(el, {
        loop: true,
        autoplay: { delay: 3500, disableOnInteraction: false },
        speed: 500,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        allowTouchMove: true
      });
    },

    _initRecommendationSwiper: function () {
      var el = this.drawer.querySelector('.cqc-rec-swiper');
      if (!el) return;
      this.swiperRec = new Swiper(el, {
        slidesPerView: 3,
        spaceBetween: 10,
        navigation: {
          nextEl: '.cqc-rec-next',
          prevEl: '.cqc-rec-prev'
        },
        breakpoints: {
          0: { slidesPerView: 2.4, spaceBetween: 8 },
          480: { slidesPerView: 3, spaceBetween: 10 }
        }
      });
    },

    /* ---- Utility: Format Money (INR) ---- */
    formatMoney: function (paise) {
      var rupees = paise / 100;
      return '₹' + rupees.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    /* ---- Utility: Escape HTML ---- */
    escapeHTML: function (str) {
      if (!str) return '';
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    },

    /* ---- Utility: Resize Shopify Image URL ---- */
    resizeImage: function (url, size) {
      if (!url) return '';
      // Insert size before the file extension
      return url.replace(/\.(jpg|jpeg|png|gif|webp)/, '_' + size + '.$1');
    }
  };

  // Boot when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { window.CQC.init(); });
  } else {
    window.CQC.init();
  }
})();
